import * as React from 'react';

import {ButtonCard} from '../card/button-card';
import {ListView} from '../list-view/list-view';
import {TwoLine} from '../two-line/two-line';

import type {Category} from './categorized-select-list';

import styles from './two-pane-select-list.module.css';

type Props<C> = {
    categorizedLists: Category<C>[] | null | undefined;
    isLoading?: boolean;
    onSelectCategory: (category: Category<C>) => void;
    selectedCategory: Category<C> | null | undefined;
    rightPanelContent: React.ReactNode;
};

export function TwoPaneSelectList<C>(props: Props<C>) {
    return (
        <div className='full-height flex gap-16'>
            <div className={styles['list-selection']}>
                <ListView
                    isLoading={props.isLoading}
                    itemSpacing={8}
                    loadingState={{
                        numItems: 3,
                        listPadding: 0,
                        spacing: 12,
                    }}
                    collection={props.categorizedLists || []}
                    renderRow={(category) => (
                        <div key={category.id} className={styles['list-item']}>
                            {category.label && (
                                <div className={styles['list-label']}>
                                    <strong>{category.label}</strong>
                                </div>
                            )}
                            <ButtonCard
                                key={category.id}
                                isSelected={Boolean(
                                    props.selectedCategory &&
                                        props.selectedCategory.id === category.id
                                )}
                                isFullWidth={true}
                                fitHeight={true}
                                onClick={() => {
                                    props.onSelectCategory(category);
                                }}
                                isDisabled={category.isDisabled}
                                tooltipText={category.isDisabled ? 'Disabled by admin' : undefined}
                            >
                                <div className='pad-16'>
                                    <TwoLine
                                        isLargeWithSmallBottomRow={true}
                                        topRow={
                                            typeof category.title === 'string' ? (
                                                <strong>{category.title}</strong>
                                            ) : (
                                                category.title
                                            )
                                        }
                                        bottomRow={category.subtitle}
                                        shouldCenterSingleLine={true}
                                    />
                                </div>
                            </ButtonCard>
                        </div>
                    )}
                />
            </div>
            {props.rightPanelContent}
        </div>
    );
}
